// extracted by mini-css-extract-plugin
export default {"image":"ResizedImage_image__EMVrc","button":"ResizedImage_button__-c87z"};